import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ths_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminApi = {
  login: (password) => axios.post(`${API}/admin/login`, { password }),
  verify: () => axios.get(`${API}/admin/verify`, authHeaders()),
  changePassword: (current_password, new_password) =>
    axios.post(`${API}/admin/change-password`, { current_password, new_password }, authHeaders()),
  getSettings: () => axios.get(`${API}/admin/settings`, authHeaders()),
  addEmail: (email) => axios.post(`${API}/admin/notify-emails`, { email }, authHeaders()),
  addEmails: (emails) => axios.post(`${API}/admin/notify-emails/bulk`, { emails }, authHeaders()),
  removeEmail: (email) => axios.delete(`${API}/admin/notify-emails?email=${encodeURIComponent(email)}`, authHeaders()),
  getBookings: () => axios.get(`${API}/admin/bookings`, authHeaders()),
  updateBooking: (id, status) => axios.patch(`${API}/admin/bookings/${id}`, { status }, authHeaders()),
  deleteBooking: (id) => axios.delete(`${API}/admin/bookings/${id}`, authHeaders()),
};

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};
